/**
 * @generated SignedSource<<12b02165b9d73c5163ce70c53a132e8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RetryReportInput = {
  reportId: string;
};
export type useReportRetryMutation$variables = {
  input: RetryReportInput;
};
export type useReportRetryMutation$data = {
  readonly retryReport: {
    readonly success: boolean | null;
  } | null;
};
export type useReportRetryMutation = {
  variables: useReportRetryMutation$variables;
  response: useReportRetryMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RetryReportPayload",
    "kind": "LinkedField",
    "name": "retryReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useReportRetryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useReportRetryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3975ef0fb1e3f02f94ae19ae8bb8fb5d",
    "id": null,
    "metadata": {},
    "name": "useReportRetryMutation",
    "operationKind": "mutation",
    "text": "mutation useReportRetryMutation(\n  $input: RetryReportInput!\n) {\n  retryReport(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "707fdc1314e3b4a3a097e802c8ef5230";

export default node;
